var map = {
	"./calm_happy.svg": 51,
	"./calm_neutral.svg": 52,
	"./calm_sad.svg": 53,
	"./calm_slightly-happy.svg": 54,
	"./calm_slightly-sad.svg": 55,
	"./energetic_happy.svg": 56,
	"./energetic_neutral.svg": 57,
	"./energetic_sad.svg": 58,
	"./energetic_slightly-happy.svg": 59,
	"./energetic_slightly-sad.svg": 60,
	"./loader.svg": 20,
	"./mudic-white.svg": 61,
	"./neutral_happy.svg": 62,
	"./neutral_neutral.svg": 63,
	"./neutral_sad.svg": 64,
	"./neutral_slightly-happy.svg": 65,
	"./neutral_slightly-sad.svg": 66
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50;